import { createContext } from 'react';

export const WinContext = createContext();
